module.exports = __webpack_public_path__ + "img/up8.629bab99.png";